<template>
  <div >
    <template v-if="showShowCaseModal">
      <ShowcaseModal :portfolio="portfolio" :selectedCarousel="selectedCarousel" :received-user="receivedUser" @close="showShowCaseModal = false"/>
    </template>
    <div v-if="requestIsDoneSuccesfully" style="background:#f4f5f7; padding-top: 40px; padding-bottom: 50px">
      <div style="width: 793px; border-radius: 10px; margin: 0 auto;box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);background-color: #ffffff;">

        <div class="deed-warning" v-if="portfolio.status === -2" style="background-color:rgba(242, 153, 51, 0.2);border:solid 1px rgba(242, 153, 51, 0.3);">
          <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
            <div style="display: flex; margin-left: 25px; align-items: center">
              <img src="https://gcdn.bionluk.com/site/cicons/ic-warning.svg" onload="SVGInject(this)" class="warning-icon-f29933"/>
              <div style="height: 50px; margin-left: 15px; display: flex; flex-direction: column; justify-content: space-between">
                <p class="warning-header" style="color:#2d3640">Portfolyon onaylanmadı.</p>
                <p class="warning-text" style="color:#2d3640"> Üzgünüz portfolyon onaylanmadı. 😞 Sebebini öğrenmek ve tekrar yayınlamak için sağ tarafta bulunan “Düzenle” ikonunu kullanabilirsin. </p>
              </div>
            </div>
            <div style="border-radius: 5px; margin-right: 30px; background-color:#f29933">
              <div style="display: flex; align-items: center; padding: 10px 20px">
                <span
                  data-balloon="Düzenle"
                  data-balloon-pos="up"
                  @click="$router.push(`/panel/portfolyo/duzenle/${uuid}`)">
                    <img src="https://gcdn.bionluk.com/site/cicons/ic-edit-penci.svg" class="action-button-svg" onload="SVGInject(this)"/>
                  </span>
              </div>
            </div>
          </div>
        </div>

        <div class="user-info-div">
          <div style="display: flex">
            <router-link :to="'/'+receivedUser.username">
              <img class="avatar" :alt="receivedUser.username" :src="receivedUser.avatar_url"/>
            </router-link>
            <div class="title-and-username">
              <h1 class="title">{{ title }}</h1>
              <p class="sub-title" v-if="portfolio.rating_user.id">{{ receivedUser.username }}, <router-link :to="'/'+portfolio.rating_user.username">{{portfolio.rating_user.username}}</router-link> için yaptı.</p>
              <p v-else class="sub-title">{{portfolio.category_sub_name}}</p>
            </div>
          </div>
        </div>

        <div class="portfolio-description">{{portfolio.description}}</div>

        <div class="stats-area">
          <div @click="likeOrShowModal" style="display: flex" :style="!favCount && receivedUser.username === user.username ? 'cursor:default!important; text-decoration:none!important' : ''">
            <img src="https://gcdn.bionluk.com/site/cicons/ic-like-fill.svg" onload="SVGInject(this)" class="red-icon-liked"/>
            <p v-if="receivedUser.username === user.username || favCount" class="number">[{{favCount}}]</p>
            <p class="textt" >{{receivedUser.username === user.username || favCount ? 'Beğeni' : 'İlk beğenen sen ol'}}</p>
          </div>
          <div style="display: flex; margin-left: 20px;">
            <img src="https://gcdn.bionluk.com/site/cicons/ic-eye-open.svg" onload="SVGInject(this)" class="eye-icon"/>
            <p class="number">{{viewCount}}</p>
            <p class="textt">Görüntülenme</p>
          </div>
        </div>

        <div class="portfolio-modal-big-img">
          <div style="position: relative;">

            <div v-if="videoLoader && ((selectedItem.video_url && selectedItem.file_type === 'video') || selectedItem.file_type === 'audio')" class="loader-div">
              <img :src="selectedItem.cover.image_url">
              <div>
                <loader style="height: 30px;width: 30px;"></loader>
              </div>
            </div>

            <div class="mediaArea">
              <div v-if="showIframe">
                <iframe @load="deactivateIframeLoader()" v-show="!videoLoader" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"
                        width="793" height="447"
                        frameborder="0" scrolling="no" :src="'https://api.bionluk.com/general/video/' + uuid +'/showcasedetail_'+selectedItem.upload_id+'x'+selectedItem.cover.upload_id+'/'"></iframe>
              </div>

              <div v-if="!showIframe">
                <img :alt="title" class="poster" :style="{width: '793px', 'cursor': (selectedItem.file_type === 'audio' || selectedItem.file_type === 'video') ? 'pointer' : 'default' }"
                     :src="selectedItem.cover.image_url"/>
              </div>
            </div>

            <div class="portfolio-share-area" @click="clickedShareButton">
              <social-sharing :url="'https://bionluk.com/freelancer-vitrin/'+uuid" inline-template>
                <div class="user-socialmedia-icons">
                  <network
                    network="facebook" style="cursor: pointer;">
                    <div data-balloon="Facebook'ta paylaş"
                         data-balloon-pos="up">
                      <img style="width: 26px; height: 26px; border-radius: 50%" src="https://gcdn.bionluk.com/site/cicons/png/facebook.png"/>
                    </div>

                  </network>

                  <network network="twitter" style="cursor: pointer; margin-left: 20px;">
                    <div data-balloon="Twitter'da paylaş"
                         data-balloon-pos="up">
                      <img style="width: 26px; height: 26px; border-radius: 50%" src="https://gcdn.bionluk.com/site/cicons/png/twitter.png"/>
                    </div>
                  </network>

                  <network network="linkedin" style="cursor: pointer; margin-left: 20px;">
                    <div data-balloon="Linkedin'de paylaş"
                         data-balloon-pos="up">
                      <img style="width: 26px; height: 26px; border-radius: 50%"src="https://gcdn.bionluk.com/site/cicons/png/linkedin.png"/>
                    </div>
                  </network>
                </div>
              </social-sharing>
              <div
                data-balloon="Direkt linki kopyala"
                data-balloon-pos="up"
                @click="copyToClipboard()" style="margin-left: 20px;">
                <img  class="share-icon" style="width: 26px; height: 26px; border-radius: 50%; cursor: pointer" src="https://gcdn.bionluk.com/site/cicons/png/link.png"/>
              </div>

            </div>
            <div v-if="!showIframe" class="show-attachment"  @click="showShowCaseModal = true">
              <img src="https://gcdn.bionluk.com/site/cicons/ic-search.svg" onload="SVGInject(this)" class="show-attachment-icon"/>
            </div>
          </div>
        </div>


        <div v-if="items && items.length > 1" class="portfolio-carusel">
          <carousel :perPage="5" :scrollPerPage="true" :navigationEnabled="true" navigationNextLabel="" navigationPrevLabel="" :paginationEnabled="false">
            <slide v-for="(item, index) in items" :key="index" :style="index % 5 !== 0 ? 'margin-left: 20px' : ''">
              <div @click="selectedCarousel = index" :class="selectedCarousel === index ? 'attachment-selected' : 'attachment'">
                <img @click="selectItem(item)" :id="'carusel-image' + index" class="attachment-img"
                     :alt="title"
                     :src="item.cover.image_url_small"/>
              </div>
            </slide>
          </carousel>
        </div>

        <div v-if="items && items.length > 1" class="sepp"></div>



        <div class="portfolio-modal-comment-main">

          <div class="modal-comment-header"><span v-if="commentCount === 0">Bu portfolyoyu beğendin mi? O zaman ilk yorumu sen yap...</span><span v-else>Yorumlar</span></div>
          <div class="modal-comment-body">


            <div :id="'comment_message'+message.id" v-for="(message, mindex) in comments.messages" v-if="!message.isDeleted">
              <div class="message-body">
                <div class="message-user-info">
                  <router-link :to="'/' + message.user.username" class="message-user-avatar-username">
                    <img class="avatar-img" :src="message.user.avatar_url"/>
                  </router-link>
                  <div class="comment-username-area">
                    <div style="display: flex; justify-content: space-between">
                      <div class="comment-username">{{message.user.username}} <p class="rating" v-if="message.rating"><img src="https://gcdn.bionluk.com/site/cicons/ic-star.svg" onload="SVGInject(this)" class="rating-icon"/></p><p class="text" v-if="message.rating">{{message.rating}}</p></div>
                      <p class="date-text">{{message.created_at}} önce</p>
                    </div>
                    <p class="comment" v-html="message.comment"></p>
                    <div class="message-functions">
                      <div style="display: flex">
                        <template v-if="!message.reply">
                          <p class="message-function" @click="replyComment(message)">[cevapla]</p>
                        </template>
                        <template  v-if="user.username !== message.user.username">
                          <span style="padding-left: 5px; padding-right: 5px">-</span>
                          <p class="message-function" @click="updateCommentLikeStatus(message)" :style="message.commentLikeStatus ? 'color: #fd4056;' : ''">[{{message.commentLikeStatus ? 'beğeniyi kaldır' : 'beğen'}}]</p>
                        </template>
                        <template v-if="user.username === message.user.username || receivedUser.uuid === user.uuid">
                          <span  style="padding-left: 5px; padding-right: 5px">-</span>
                          <p class="message-function" @click="commentDelete(message)">[sil]</p>
                        </template>
                      </div>


                      <div class="message-like-count" v-if="message.commentLikeCount > 0">
                        <div @click="getUserLikes('portfolio_comment', message.id)" style="display: flex" v-show="message.commentLikeStatus">
                          <img src="https://gcdn.bionluk.com/site/cicons/ic-like-fill.svg" onload="SVGInject(this)" class="comments-like-icon-liked"/>
                          <p class="liked">[{{message.commentLikeCount}}]</p>
                        </div>
                        <div @click="getUserLikes('portfolio_comment', message.id)" style="display: flex" v-show="!message.commentLikeStatus">
                          <img src="https://gcdn.bionluk.com/site/cicons/ic-like-fill.svg" onload="SVGInject(this)" class="comments-like-icon"/>
                          <p class="not-liked">[{{message.commentLikeCount}}]</p>
                        </div>
                      </div>
                    </div>

                    <div v-if="message.reply">
                      <div style="background-color: rgba(191, 200, 210,0.5);height: 1px;width: 567px;margin-top:25px;"></div>
                      <div class="replied-message">
                        <router-link :to="'/' + receivedUser.username" class="message-user-avatar-username">
                          <img class="avatar-img-replied" :src="receivedUser.avatar_url"/>
                        </router-link>
                        <div style="margin-left: 16px">
                          <p class="comment-username">{{receivedUser.username}}</p>
                          <div class="comment" style="margin-top: 7px;" v-html="`<span style='color:#00a575; font-weight: 600'>@`+message.user.username+`</span> `+message.reply"></div>
                          <div class="message-functions">
                            <p  v-if=" receivedUser.uuid === user.uuid" class="message-function" @click="replyDelete(message, mindex)">[sil]</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div v-if="mindex === 0 && comments.messages.length > 1" class="go-gig">
                <img class="avatar-go-gig" :src="receivedUser.avatar_url">
                <p class="text-go-gig"><span style="font-weight: 600;">{{receivedUser.username}} </span>kullanıcısının işlerini beğendiysen;<br/> <span style="font-size: 16px;color: #eaedf2">iş ilanlarını incelemeni tavsiye ederiz. Belki de ihtiyacın olan o işi birlikte yaparsınız.</span> 😉</p>
                <router-link :to="'/'+receivedUser.username" class="cuper-white-button" style=" width: 150px; height: 44px">İlanlara Göz at</router-link>
              </div>
            </div>


            <div style="position:relative;">
              <div :class="{'emoji-img': true, 'emoji-img-active': openEmojiPicker}" @click="openEmojiPicker = !openEmojiPicker"></div>
              <emoji-picker class="emoji-picker"
                            v-click-outside="pageClickHandler"
                            v-if="openEmojiPicker"
                            :emojiSize="32"
                            :emojisByRow="7"
                            :showSearch="true"
                            :i18n="{ search: 'Ara...'}"
                            @select="addEmoji"/>

            </div>
            <textarea @click="openEmojiPicker = false" v-model="newComment" id="comment-input" maxlength="300" class="comment-text-area"></textarea>
            <div style="color: #8b95a1; font-size: 13px; font-weight: 500;display: flex; justify-content: flex-end; margin-top: 10px;">
              {{newComment.length}} / <span style="color: #2d3640">300</span>
            </div>


            <div style="display: flex; flex-direction: row-reverse; margin-top: 20px;">
              <button style="width: 160px; height: 54px;" @click="saveComment()" :disabled="buttonLoading || !newComment.length" class="cuper-green-button">Gönder</button>
            </div>
          </div>
        </div>





      </div>
    </div>
    <loader v-else/>
  </div>
</template>

<script>
  import { VEmojiPicker } from "v-emoji-picker-bi";
  import CustomButton from "../../../components/CustomButton";
  import ShowcaseModal from "../../../components/ShowcaseModal";
  export default {
    name: "src-pages-body-showcase-detail-v3",
    components: {
      ShowcaseModal,
      CustomButton,emojiPicker: VEmojiPicker
    },
    data() {
      return {
        showShowCaseModal: false,
        commentCount: null,
        description: null,
        favCount: null,
        fileUrl: null,
        title: null,
        receivedUser: {},
        uuid: null,
        viewCount: null,
        comments: [],
        newComment: '',
        likeStatus: null,
        fileType: null,
        videoURL: null,
        imageURLOriginal: null,
        likes: [],
        showLikeModal: null,
        disableFollowButton: null,
        loaderLikes: null,
        items: [],
        disapprovalReasons: [],
        videoLoader: false,
        requestIsDoneSuccesfully: false,

        selectedCarousel:0,
        selectedItem:{},

        openEmojiPicker: false,

        repliedCommentId:null,
        portfolio:{},
        buttonLoading:false,

      }
    },
    methods: {

      sendMessage(user) {

        if (!this.$store.state.user.uuid) {
          this.$router.push("/login");
        } else {

          if(this.buttonLoading === false){
            this.buttonLoading = true;
            this.api.workstation.chatOpen(user.username, 0,1)
              .then(({data}) => {
                let result = data;
                if (result.success) {
                  let conversationSendData = {
                    r_username: user.username,
                    r_avatar_url: user.avatar_url,
                    r_id: user.user_id,
                    r_uuid: user.uuid,
                    fromWhere: 'Portfolio Detail',
                    c_uuid: result.data.c_uuid,
                  };
                  this.EventBus.$emit('externalOpenChat', conversationSendData);
                } else {
                  this.$toasted.global.errorToast({description: result.message});
                }
                this.buttonLoading = false;
              })
              .catch(err => {
                this.buttonLoading = false;
                this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE});
              });
          }
        }

      },

      changeStatus(portfolio, status) {
        if(this.disabledButtons) return false
        if (status === -1) {
          if (confirm("Portfolyondan bu içeriği silmek istediğinden emin misin? Eğer silersen ilgili iş ilanlarından da bu içeriği çıkartacağız") === true){
            this.disabledButtons = true;
            this.api.seller.deletePortfolio(portfolio.uuid, this.$Progress)
              .then(({data}) => {
                let result = data;
                if (result.success) {
                  this.$toasted.global.infoToast({description: result.message});
                  this.$router.push('/portfolyo/'+this.receivedUser.username);
                  this.disabledButtons = false;
                  this.hide()
                } else {
                  this.$toasted.global.errorToast({description: result.message});
                  this.disabledButtons = false;
                }
              })
              .catch(err => {
                this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE});
                this.disabledButtons = false;
              });
          }
        } else {
          this.disabledButtons = true;
          this.api.seller.changePortfolioStatus(portfolio.uuid, status, this.$Progress)
            .then(({data}) => {
              let result = data;
              if (result.success) {
                this.$toasted.global.infoToast({description: result.message});
                this.disabledButtons = false;
                this.$router.push('/portfolyo/'+this.receivedUser.username);
                this.hide();
              } else {
                this.$toasted.global.errorToast({description: result.message});
                this.disabledButtons = false;
              }
            })
            .catch(err => {
              this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE});
              this.disabledButtons = false;
            });
        }
      },
      addEmoji(emoji) {
        this.newComment = this.newComment + " " + emoji.data;
        const ele = document.getElementById('comment-input');
        ele.focus();
        this.openEmojiPicker = false;
      },
      pageClickHandler(event) {
        this.openEmojiPicker = false;
      },

      copyToClipboard(){
        const el = document.createElement('textarea');
        el.value = 'https://bionluk.com/freelancer-vitrin/'+this.uuid;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.$toasted.global.infoToast({description: 'Portfolyo linki kopyalandı.'});
      },

      clickedShareButton(){
        this.Helper.trackEvents.customEvent("clicked", {version:'v1',page:this.$store.state.componentMap.page,what:'portfolio share buttons'});
      },

      selectItem(item){
        this.selectedItem = item;
      },
      likeOrShowModal(){

        if(this.favCount){
          this.getUserLikes('portfolio', this.uuid);
        } else {
          if(this.receivedUser.username === this.user.username){
            return false;
          } else {
            this.updatePorfolioLikeStatus(this.uuid, this.likeStatus.action)
          }
        }
      },

      replyDelete(message, mindex){
        this.comments.messages[mindex].reply = null;
        this.api.general.portfolioCommentDelete("portfolio_reply", message.id)
          .then(({data}) => {
            let result = data;
            if (result.success) {

            } else {
              this.$toasted.global.errorToast({description: result.message});
            }
          });
      },

      replyComment(message){
        this.newComment = '@'+message.user.username + ' ';
        const ele = document.getElementById('comment-input');
        if(message.rating){
          this.repliedCommentId = message.id;
        }
        ele.focus();
      },


      openWorkstationPortfolioPage() {
        this.$router.push("/panel/portfolyo");
      },
      deactivateIframeLoader() {
        this.videoLoader = false;
      },
      showIframeByType(fileType, videoURL) {
        this.videoLoader = true;
        if (videoURL && (fileType === 'audio' || fileType === 'video')) {
          this.showIframe = true;
        }
      },

      routeShowCase(path) {
        this.$store.state.showCase.from = this.$store.state.route.fullPath;
        this.$store.state.showCase.to = path;
        this.$store.state.showCase.byModal = this.Modals.PORTFOLIO;
        this.hide();
        this.$router.push(path);
      },

      getUserLikes(type, uuid) {
        this.api.general.getLikedUsers(type, uuid)
          .then(({data}) => {
            let result = data;
            if (result.success) {
              this.$store.commit(this.types.ACTIVE_MODAL, {modalType: this.Modals.GET_LIKED_USERS, info: { id: uuid, likes: result.data.likes, likeCount: result.data.likeCount }});
            } else {
              this.$toasted.global.errorToast({description: result.message});
            }
          })
          .catch(err => {
            this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE});
          });
      },

      scrollAndFocusCommentInput() {
        this.$nextTick(() => {
          document.getElementsByClassName("write-comment-input")[0].focus();
        });
      },

      followAction(like) {
        this.disableFollowButton = true;
        this.api.user.updateFollowStatus(like.u_uuid, like.followStatus.action,this.$store.state.componentMap.page)
          .then(({data}) => {
            let result = data;
            this.disableFollowButton = false;

            if (result.success) {
              like.followStatus = result.data.followStatus;
            } else {
              this.$toasted.global.errorToast({description: result.message});
              this.$router.push(result.data.redirect_url);
            }
          })
          .catch(err => {
            this.disableFollowButton = false;
            this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE});
          });
      },

      saveComment() {
        this.api.general.savePortfolioComment(this.uuid, this.newComment, this.repliedCommentId, this.$Progress)
          .then(({data}) => {
            let result = data;
            if (result.success) {
              if(result.data && result.data.saveType && result.data.saveType === 'update'){
                let mindex = this.comments.messages.findIndex(m => m.id === this.repliedCommentId);
                this.comments.messages[mindex].reply = result.data.comment;
                this.newComment = '';
                let doc_id = 'comment_message'+this.repliedCommentId;
                document.getElementById(doc_id).scrollIntoView({
                  behavior: 'smooth'
                });
              } else {
                result.data.created_at = this.calculateElapsedTime(+new Date() - 1000)
                result.data.isDeleted = false;
                result.data.commentLikeCount = 0;
                result.data.commentLikeStatus = false;
                if(result.data.comment && result.data.comment.substr(0, 1) === '@'){
                  let firstWord = result.data.comment.replace(/ .*/,'');
                  let withoutFirstWord = result.data.comment.substr(result.data.comment.indexOf(" ") + 1);
                  result.data.comment = '<a target="_blank" href="/'+firstWord.substr(1)+'" style="color:#00a575; font-weight: 600">'+firstWord+'</a> '+withoutFirstWord;
                }
                this.comments.messages.push(result.data);
                this.commentCount += 1;
                this.comments.commentCount = this.commentCount;
                this.newComment = '';
                this.EventBus.$emit("modalPortfolioUpdated", {comments: this.comments, favCount: this.favCount, portfolioUuid: this.uuid});
              }

            } else {
              this.$toasted.global.errorToast({description: result.message});
            }
          })
          .catch(err => {
            console.log(err);
            this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE});
          })
      },

      hide() {
        this.$store.commit(this.types.DISABLE_MODAL);
      },

      updatePorfolioLikeStatus(uuid, action) {
        this.api.general.updateLikeStatus(this.Constants.FAV_TYPES.PORTFOLIO, action, uuid,null,this.$store.state.componentMap.page)
          .then(({data}) => {
            let result = data;

            if (result.success) {
              result.data.created_at = this.calculateElapsedTime(+new Date() - 1000)
              this.favCount += action;
              this.$toasted.global.infoToast({description: result.message});
            } else {
              this.$toasted.global.errorToast({description: result.message});
              this.revertLikeStatus();
            }
          })
          .catch(err => {
            this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE});
            this.revertLikeStatus();
          });
        this.reverseLikeStatus();
      },

      revertLikeStatus() {
        let newLikeIconText = "Beğen";
        let newLikedIconText = "Beğen";
        if (this.likeStatus.action === this.imageUrls.likeIcon.action) {
          this.likeStatus = {
            actionIcon: this.imageUrls.likeIcon.url.split("https://gcdn.bionluk.com/site/").pop(),
            action: this.imageUrls.likeIcon.action,
            actionText: newLikeIconText
          };
        } else {
          this.likeStatus = {
            actionIcon: this.imageUrls.likedIcon.url.split("https://gcdn.bionluk.com/site/").pop(),
            action: this.imageUrls.likedIcon.action,
            actionText: newLikedIconText
          };
        }
      },

      reverseLikeStatus() {
        let newLikeIconText = "Beğen";
        let newLikedIconText = "Beğen";
        if (this.likeStatus.action === this.imageUrls.likeIcon.action) {
          this.likeStatus = {
            actionIcon: this.imageUrls.likedIcon.url.split("https://gcdn.bionluk.com/site/").pop(),
            action: this.imageUrls.likedIcon.action,
            actionText: newLikedIconText
          };
        } else {
          this.likeStatus = {
            actionIcon: this.imageUrls.likeIcon.url.split("https://gcdn.bionluk.com/site/").pop(),
            action: this.imageUrls.likeIcon.action,
            actionText: newLikeIconText
          };
        }
      },
      updateCommentLikeStatus(message) {
        let action = message.commentLikeStatus ? -1 : 1;
        this.api.general.portfolioCommentLike("portfolio_comment", action, message.id)
          .then(({data}) => {
            let result = data;

            if (result.success) {
              this.$toasted.global.infoToast({description: result.message});
            } else {
              this.$toasted.global.errorToast({description: result.message});
              this.revertOrReverseLikeStatus(message);
            }
          })
          .catch(err => {
            this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE});
            this.revertOrReverseLikeStatus(message);
          });
        this.revertOrReverseLikeStatus(message);
      },

      revertOrReverseLikeStatus(message) {
        if (message.commentLikeStatus) {
          message.commentLikeCount = message.commentLikeCount - 1;
        }
        else if (!message.commentLikeStatus) {
          message.commentLikeCount = message.commentLikeCount + 1;
        }
        message.commentLikeStatus = !message.commentLikeStatus;
      },

      commentDelete(message) {
        this.api.general.portfolioCommentDelete("portfolio", message.id)
          .then(({data}) => {
            let result = data;

            if (result.success) {
              this.$toasted.global.infoToast({description: result.message});
              this.EventBus.$emit("modalPortfolioUpdated", {comments: this.comments, favCount: this.favCount, portfolioUuid: this.uuid});
            } else {
              this.$toasted.global.errorToast({description: result.message});
              this.deleteOrUndoMessage(message);
            }
          })
          .catch(err => {
            this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE});
            this.deleteOrUndoMessage(message);
          });
        this.deleteOrUndoMessage(message);
      },

      deleteOrUndoMessage(message) {
        message.isDeleted = !message.isDeleted;
        if (message.isDeleted) {
          this.commentCount -= 1;
        } else {
          this.commentCount += 1;
        }
        let temp = this.comments;
        this.comments = Object.assign({}, temp);
      },

      getPorfolioData() {
        if (!this.uuid) {

          let t = this.route.query && this.route.query['t'] && this.route.query['t'] === 'a' ? 'a' : null;
          this.uuid = this.$store.state.routerParams[0];
          this.api.seller.getPortfolio(this.uuid, t, this.$Progress)
            .then(({data}) => {
              let result = data;
              if (result.success) {
                this.$store.state.indexHTMLTitle = result.data.meta.title;
                this.$store.state.indexHTMLMetaDescription = result.data.meta.description;
                this.commentCount = result.data.portfolio.comment_count;
                this.favCount = result.data.portfolio.fav_count;
                this.viewCount = result.data.portfolio.viewCount;
                this.description = result.data.portfolio.description;
                this.fileUrl = result.data.portfolio.image_url;
                this.title = result.data.portfolio.name;
                this.receivedUser = result.data.portfolio.user;
                this.comments = result.data.portfolio.comments;
                this.likeStatus = result.data.portfolio.likeStatus;
                this.fileType = result.data.portfolio.file_type;
                this.videoURL = result.data.portfolio.video_url;
                this.imageURLOriginal = result.data.portfolio.image_url_original;
                this.items = this.items.concat(result.data.portfolio.items);
                this.disapprovalReasons = result.data.portfolio.disapproval_reasons;

                this.comments.messages.forEach(comment => {
                  comment.isDeleted = false;
                  comment.created_at = this.calculateElapsedTime(comment.created_at)
                  if(comment.comment && comment.comment.substr(0, 1) === '@'){
                    let firstWord = comment.comment.replace(/ .*/,'');
                    let withoutFirstWord = comment.comment.substr(comment.comment.indexOf(" ") + 1);
                    comment.comment = '<a target="_blank" href="/'+firstWord.substr(1)+'" style="color:#00a575; font-weight: 600">'+firstWord+'</a> '+withoutFirstWord;
                  }
                });
                this.likes = result.data.portfolio.likes;
                this.requestIsDoneSuccesfully = true;

                this.portfolio = result.data.portfolio;
                this.selectedItem = result.data.portfolio.items.length > 0 ? result.data.portfolio.items[0] : {};


                this.setFacebookMetaProperties(result.data.meta.facebookMeta);

                this.Helper.trackEvents.pageView(this.Helper.createProjectShowcaseDetailPageProps(result.data.portfolio));
              } else {
                this.requestIsDoneSuccesfully = false;
                this.sendPrerender302(result.data.redirect_url,"302");
                if(!result.data.soft_redirect){
                  this.$toasted.global.errorToast({description: result.message});
                }
              }
            })
            .catch(err => {
              console.log(err);
              this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE});
              this.requestIsDoneSuccesfully = false;
            });
        } else {
          this.requestIsDoneSuccesfully = false;
          this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE});
        }
      }
    },


    computed: {
      showIframe: function () {
        if ((this.selectedItem.video_url && this.selectedItem.file_type === 'video') || this.selectedItem.file_type === 'audio') {
          return true;
        } else {
          return false;
        }
      }
    },
    created() {
      this.getPorfolioData();
    }
  }

</script>

<style scoped lang="scss">


.warning-icon-f29933 /deep/ {

  width: 36px;
  height: 36px;
  path {
    fill: #f29933!important;
  }
}
  .own-icons{
    display: flex;
    .own-icon-container{
      cursor: pointer;
      margin-left: 24px;

      .own-icon /deep/ {
        width: 24px;
        height: 24px;
        path {
          fill: #bfc8d2!important;

        }
      }
      &:hover{
        .own-icon /deep/ {
          width: 24px;
          height: 24px;
          path {
            fill: #5e6b79!important;

          }
        }
      }
    }
  }


  .modal-mask {
    overflow-y: scroll;
    background-color: rgba(0, 0, 0, .8);
  }



  .stats-area{

    display: flex;
    width: 693px;
    margin:0 auto 20px;

    div{
      &:first-child {
        cursor: pointer;
        &:hover{
          text-decoration: underline;
        }
      }
    }

    .number{
      margin-left: 5px;
      font-size: 16px;
      font-weight: 600;
      line-height: 1.5;
      color: #2d3640;
    }

    .textt{
      margin-left: 5px;
      font-size: 16px;
      font-weight: 300;
      line-height: 1.5;
      color: #5e6b79;
    }

    .red-icon-liked /deep/ {
      width: 14px;
      height: 14px;
      margin-top: 6px;
      path {
        fill: #fd4056!important;
      }
    }

    .eye-icon /deep/ {
      width: 16px;
      height: 16px;
      margin-top: 5px;
      path {
        fill: #1da1f2!important;
      }
    }
  }

  .cuper-white-button{
    &:hover{
      text-decoration: none!important;
    }
  }

  .go-gig{
    width: 700px;
    height: 116px;
    border-radius: 10px;
    background-image: linear-gradient(100deg, #43c1be 1%, #54aeb8 100%);

    margin-top: 20px;
    display: flex;
    align-items: center;


    .avatar-go-gig{
      margin-left: 30px;
      width: 58px;
      height: 58px;
      border-radius: 50%;
      border:1px solid #ffffff;
    }

    .text-go-gig{
      max-width: 390px;
      margin-left: 20px;
      font-size: 18px;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #ffffff;
    }
  }


  .replied-message{
    display: flex;
    margin-top: 25px;
    .avatar-img-replied{
      width: 49px;
      height: 49px;
      border-radius: 50%;
      border: 1px solid #eaedf2;
    }

  }


  .emoji-img {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 15px;
    top: 106px;
    cursor: pointer;
    z-index: 2;
    background-image: url('https://gcdn.bionluk.com/site/icon/smile/smile-icon.svg');
    background-repeat: no-repeat;
    -webkit-background-size: contain;
    background-size: contain;

    &:hover {
      background-image: url('https://gcdn.bionluk.com/site/icon/smile/smile-icon_hover.svg');
      width: 22px;
      height: 22px;
      right: 14px;
      top: 105px;
    }
  }

  .emoji-img-active {
    background-image: url('https://gcdn.bionluk.com/site/icon/smile/smile-icon_hover.svg') !important;
  }

  .emoji-picker {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 5px 10px 0px;
    position: absolute;
    right: 8px;
    top: -182px;
    z-index: 3;
  }



  .message-body{
    margin-top: 20px;
    width: 700px;
    min-height: 149px;
    border-radius: 10px;
    box-shadow: 0 0 0 0 rgba(45, 54, 64, 0.05);
    border: solid 1px #eaedf2;
    background-color: rgba(239, 243, 248,0.5);

    .message-user-info{
      display: flex;
      margin:30px 30px 20px;
      .avatar-img{
        width: 58px;
        height: 58px;
        border-radius: 50%;
        border:2px solid #eaedf2;
      }

      .comment-username-area{
        margin-left: 15px;
        width: 100%;
        display: flex;
        flex-direction: column;
        .comment-username{
          display: flex;
          align-items: center;
          font-size: 18px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #4b4f52;

          .text{
            font-size: 14px;
            font-weight: bold;
            padding-left: 2px;
            color: #ffbe00;
          }

          .rating{
            padding-left: 5px;
            .rating-icon /deep/ {
              width: 16px;
              height: 16px;
              margin-top: 6px;
              path {
                fill: #ffbf00!important;
              }
            }


          }
        }
        .date-text{
          font-size: 14px;
          font-weight: normal;
          color: #bfc8d2;
        }

        .comment{
          margin-top: 10px;
          font-size: 16px;
          font-weight: 300;
          line-height: 1.5;
          color: #5e6b79;
        }

        .message-functions{
          margin-top: 15px;
          font-size: 16px;
          font-weight: 500;
          line-height: 1.5;
          color: #5e6b79;
          display: flex;
          justify-content: space-between;
          .message-function{
            cursor: pointer;
            &:hover{
              text-decoration: underline;
              color: #5e6b79;
            }
          }

          .message-like-count{
            font-size: 16px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: -0.3px;
            text-align: center;

            .not-liked{
              margin-left: 7px;
              color: #8b95a1;
              cursor: pointer;
              &:hover{
                text-decoration: underline;
              }
            }
            .liked{
              margin-left: 7px;
              cursor: pointer;
              color: #2d3640;
              &:hover{
                text-decoration: underline;
              }
            }



            .comments-like-icon /deep/ {
              width: 14px;
              height: 14px;
              margin-top: 6px;
              path {
                fill: #8b95a1!important;
              }
            }

            .comments-like-icon-liked /deep/ {
              width: 14px;
              height: 14px;
              margin-top: 6px;
              path {
                fill: #fd4056!important;
              }
            }
          }
        }
      }
    }



  }

  .sepp{
    width: 700px;
    height: 1px;
    opacity: 0.3;
    background-color: #bfc8d2;
    margin: 30px auto 0;

  }
  .portfolio-carusel {
    text-align: left;
    width: 700px;
    margin-left: 50px;
    margin-right: 50px;
    margin-top: 25px;
    align-items: center;

  }

  .like-icon /deep/ {
    width: 14px;
    height: 14px;
    margin-top: 2px;
    path {
      fill: #8b95a1!important;
    }
  }

  .like-icon-white /deep/ {
    width: 14px;
    height: 14px;
    margin-top: 2px;
    path {
      fill: #fff!important;
    }
  }





  .portfolio-description{
    font-size: 16px;
    font-weight: normal;
    line-height: 1.63;
    color: #5e6b79;
    max-width: 693px;
    margin:30px 50px;

  }

  .user-info-div {
    background: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 30px;
    margin-right: 30px;
    padding-top: 30px;


    .avatar {
      width: 58px;
      height: 58px;
      border-radius: 50%;
      border:2px solid #bfc8d2
    }

    .title-and-username {
      margin-left: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .title {
        font-size: 18px;
        font-weight: 600;
        letter-spacing: -0.56px;
        color: #2d3640;
        margin: 0;
      }

      .sub-title {
        margin-top: 5px;
        font-size: 16px;
        font-weight: 300;
        color: #8b95a1;
        a{
          font-size: 16px;
          font-weight: 600;
          color: #fa4a5e;
          &:hover{
            text-decoration: underline;
          }
        }
      }

    }

  }


  .share-icon{
    img{
      width: 26px;
      height: 26px;
      border-radius: 50%;
      cursor: pointer;
    }
  }

  .user-socialmedia-icons {
    display: flex;
    flex-direction: row;
    height: 26px;
  }
  .portfolio-share-area{

    position: absolute;
    top:15px;
    right:15px;
    width: 204px;
    height: 46px;
    border-radius: 10px;
    background-color: #eaedf2;
    display: flex;
    align-items: center;
    justify-content: center;


  }
  .show-attachment{
    cursor: pointer;
    position: absolute;
    bottom: 25px;
    left: 25px;
    width: 50px;
    height: 50px;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover{
      opacity: 0.8;
    }

    .show-attachment-icon /deep/ {
      width: 26px;
      height: 26px;
      path {
        fill: #2d3640!important;
      }
    }
  }
  .portfolio-modal-big-img {
    width: 793px;
    height: 447px;
    margin-top: 16px;
    background-color: #ffffff;
  }

  .attachment-selected{

    width: 120px;
    height: 68px;
    border-radius: 10px;
    border: solid 2px #00a575;
    display: flex;
    align-items: center;
    justify-content: center;
    .attachment-img{
      width: 115px;
      border-radius: 7px;
    }
  }


  .attachment{

    width: 120px;
    height: 68px;
    border-radius: 10px;
    border: solid 2px #fff;

    display: flex;
    align-items: center;
    justify-content: center;
    .attachment-img{
      cursor: pointer;
      width: 115px;
      border: solid 1px #eaedf2;
      border-radius: 7px;
    }
  }




  .portfolio-modal-close-button {
    position: absolute;
    top: 20px;
    right: 160px;
    z-index: 999799 !important;
    cursor: pointer;
    width: 24px;
    height: 24px;
  }

  .modal-container {
    margin: auto;
    margin-top: 60px;
    padding: 0;
    min-width: 1140px;
    height: 617px;
    background-color: #ffffff;
    box-shadow: 0 20px 30px 0 rgba(0, 0, 0, 0.15);
    border: solid 1px #ffffff;
    overflow-y: scroll;
  }

  .portfolio-modal-body {
    display: flex;
    flex-direction: column;
    border-left: 1px solid #eaedf2;
    border-right: 1px solid #eaedf2;
    border-bottom: 1px solid #eaedf2;
    width: 752px;
    margin-bottom: 60px;
    margin-left: auto;
    margin-right: auto;
  }

  .portfolio-modal-review-main {
    width: 700px;
    padding: 22px 23px 0 25px;
  }




  .loader-div {
    position: relative;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      object-fit: cover
    }

    div {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .playIcon {
    cursor: pointer;
    z-index: 9;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 60px;
    width: 60px;
    border: 2px solid white;
    background-color: white;
    border-radius: 50%;
    img {
      height: 60px;
      width: 60px;
    }
  }




  /*comment*/
  .portfolio-modal-comment-main {

    width: 700px;
    margin: 0 auto;
    padding-top: 30px;
    padding-bottom: 30px;
    .modal-comment-header {
      font-size: 20px;
      font-weight: 500;
      color: #2d3640;
    }

    .comment-text-area{
      margin-top: 23px;
      width: 653px;
      height: 70px;
      border-radius: 2px;
      border: solid 1px rgba(75, 79, 82, 0.2);
      background-color: #eff3f8;
      padding: 20px;
      opacity: 0.5;
      font-size: 16px;
      font-weight: 300;
      line-height: 1.5;
      color: #2d3640;
      &:focus{
        opacity: 1;
        background-color: #fff;
      }
    }
  }



  .bounce-enter-active {
    animation: bounce-in .5s;
  }

  .bounce-leave-to {
    animation: bounce-out .0s;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0.2);
    }
    50% {
      transform: scale(1.3);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes bounce-out {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }

  .disapproval_reason {
    height: auto;
    background-color: #FFBF00;
    border-radius: 5px;
    width: 100%;
    margin-bottom: 20px;
  }

  .disapproval_reason_inner {
    width: 700px;
    text-align: center;
    margin: 0 auto;
    padding-top: 14px;
    padding-bottom: 24px;
  }

.action-button-svg /deep/ {
  cursor: pointer;
  width: 22px;
  height: 22px;
  path {
    fill: #ffffff!important;
  }
}

  .deed-warning {
    width: 100%;
    height: 110px;
    margin-top: 27px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .warning-header {
    font-size: 20px;
    font-weight: bold;
    line-height: 1.44;
    color: #2d3640;
  }

  .warning-text {
    font-size: 15px;
    line-height: 1.44;
    font-weight: 300;
    color: #2d3640;
    padding-bottom: 10px;
  }

  .warning-action-button {
    width: 134px;
    height: 44px;
    border-radius: 2px;
    background-color: #ffffff;
    border: solid 1px #c6c8ca;
    font-size: 14px;
    font-weight: 600;
    color: #2d3640;
    margin-left: 20px;
  }

  .warning-action-button:hover {
    background-color: #fbfbfb !important;
  }


</style>
